import { FacebookPage } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchFacebookPages = async (): Promise<FacebookPage[]> =>
    privateApiWithRouteLeavingCancelation.get<FacebookPage[]>('facebook/graph/facebook-pages');

const cancelableFetchFacebookPage = async (facebookPageId: string): Promise<FacebookPage> =>
    privateApiWithRouteLeavingCancelation.get<FacebookPage>(`facebook/graph/facebook-pages/${facebookPageId}`);

export const CancelableFacebookPageGateway = {
    cancelableFetchFacebookPages,
    cancelableFetchFacebookPage,
};
